import * as z from 'zod/mini';

export const DistanceOptions = [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];

export const DefaultDistanceValue = 1500;

export const calculateCostPerMonth = (costPerKilometer: number | undefined, distance: number) => {
  if (!costPerKilometer) return undefined;
  return parseInt(((costPerKilometer * distance * 10) / 12).toFixed(0), 10);
};

export const EvCalculationSchema = z.object({
  id: z.string(),
  distance: z.number(),
  kwhCost: z.optional(z.number()),
  view: z.enum(['own', 'default']),
});

export type EvCalculationViewEnum = z.infer<typeof EvCalculationSchema>['view'];

export type EvCalculationForm = z.infer<typeof EvCalculationSchema>;

export const getDefaultValues = (id: string): EvCalculationForm => ({
  id,
  distance: 1500,
  kwhCost: undefined,
  view: 'default',
});

interface ToPayloadVariables {
  id: string;
  view: 'own' | 'default';
  kwhCost?: number;
}

export const formToPayload = ({ id, view, kwhCost }: ToPayloadVariables) => ({
  id,
  kwhCost: view === 'own' && kwhCost !== undefined ? kwhCost / 100 : undefined,
});
